import React from 'react';

const AvanttiLogo: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M10.8048 1.89337L0.248158 19.5299C-0.486529 20.7573 0.498313 22.2477 2.0438 22.2477C2.87688 22.2477 3.64406 21.839 4.0469 21.1807L11.714 7.89495C11.8435 7.67061 12.199 7.67061 12.3285 7.89495L19.9956 21.183C20.3984 21.8413 21.1656 22.25 21.9987 22.25C23.5098 22.25 24.4743 20.7945 23.7595 19.5928L13.2386 1.89337C12.7044 1.03554 11.3381 1.03554 10.8048 1.89337Z" fill="currentColor" />
  </svg>
);

export default AvanttiLogo;
